<div class="modal" tabindex="-1" role="dialog" style="display: block;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-primary" style="width: 93%; height: 100%;">
          <i class="fas fa-file-alt icon-header"></i>
          {{eventLabel}}: {{eventDisplayName}}
        </h4>
        <button type="button" class="btn hover-coursor" (click)="closePopup()">
          <i class="fal fa-times p-2" aria-hidden="true" data-bs-toggle="tooltip" data-bs-placement="top"
            title="{{closeLabel}}">
          </i>
        </button>
      </div>
      <div class="modal-body mx-2 px-3 custom-area contant-box-h">
        <div style="width:100%;display: flex; justify-content: flex-start;" *ngIf="eventDetails.ViolationId != null">
          <span style="font-weight: bold;">{{sessionIdLabel}}:&nbsp;</span>
          <span>{{eventDetails.ViolationId}}</span>
        </div>
        <div style="width:100%;" *ngIf="eventDetails.CallSummary != null">
          <div style="width:100%">
            <span style="font-weight: bold;">{{callSummaryLabel}}:&nbsp;</span>
          </div>
          <span>{{eventDetails.CallSummary}}</span>
        </div>
        <div style="width:100%;height:500px;overflow-y: auto;margin-top: 10px;">
          <ng-container *ngFor="let profanityDetails of eventDetails.ProfanityDetails; index as i">
            <div class="modal-body mx-2 px-3 custom-area contant-box-h"
              style="background-color: #e0e0e0;border-radius: 10px;margin-bottom: 10px;">
              <div style="width:100%;display: flex; justify-content: flex-start;"
                *ngIf="eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0 && eventDetails.ProfanityDetails[i].MessageSource != null">
                <span style="font-weight: bold;">{{messageSourceLabel}}:&nbsp;</span>
                <span>{{eventDetails.ProfanityDetails[i].MessageSource}}</span>
              </div>
              <div style="width:100%;margin-top:5px;"
                *ngIf="eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0 && eventDetails.ProfanityDetails[i].CreatedDateTime != null">
                <span style="font-weight: bold;">{{timestampLabel}}:&nbsp;</span>
                <span>{{formatDateTime(eventDetails.ProfanityDetails[i].CreatedDateTime) | date : 'short'}}</span>
              </div>
              <div style="width:100%;margin-top:5px;"
                *ngIf="eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0 && eventDetails.ProfanityDetails[i].OriginalSpeechResult != null">
                <label for="___saOriginalSpeechText" style="font-weight: bold;">{{originalSpeechLabel}}</label>
                <textarea id="___saOriginalSpeechText" disabled rows="2"
                  style="width:100%; margin-top: 2px;">{{eventDetails.ProfanityDetails[i].OriginalSpeechResult}}</textarea>
              </div>
              <div style="width:100%;margin-top:5px;"
                *ngIf="eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0 && eventDetails.ProfanityDetails[i].ProfanityWords != null">
                <label for="___profanityWordsDetectedContainer"
                  style="font-weight: bold;">{{profanityDetectedLabel}}</label>
                <ng-container id="___profanityWordsDetectedContainer"
                  *ngFor="let profanityWord of eventDetails.ProfanityDetails[i].ProfanityWords; index as j">
                  <div style="width: 100%;margin-top: 2px;">
                    <span> {{j+1}}. {{profanityWord}}</span>
                  </div>
                </ng-container>
              </div>
              <div style="width:100%;margin-top:5px;"
                *ngIf="eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0 && eventDetails.ProfanityDetails[i].LastAudioUrl != null && eventDetails.ProfanityDetails[i].LastAudioUrl !== ''">
                <label for="___profanityWordsAgentAudioContainer_{{i}}"
                  style="font-weight: bold;">{{profanityAgentAudioLabel}}</label>
                <div id="___profanityWordsAgentAudioContainer_{{i}}">
                  <audio src="{{eventDetails.ProfanityDetails[i].LastAudioUrl}}" controls
                    style="width:100%; margin-top: 2px;">
                  </audio>
                </div>
              </div>
              <div style="width:100%;margin-top:5px;"
                *ngIf="eventDetails.ProfanityDetails != null && eventDetails.ProfanityDetails.length > 0 && eventDetails.ProfanityDetails[i].LastAudioUrlCustomer != null && eventDetails.ProfanityDetails[i].LastAudioUrlCustomer !== ''">
                <label for="___profanityWordsCustomerAudioContainer_{{i}}"
                  style="font-weight: bold;">{{profanityCustomerAudioLabel}}</label>
                <div id="___profanityWordsCustomerAudioContainer_{{i}}">
                  <audio src="{{eventDetails.ProfanityDetails[i].LastAudioUrlCustomer}}" controls
                    style="width:100%; margin-top: 2px;">
                  </audio>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer py-2">
        <div class="w-100">
        </div>
        <div>
          <div>
            <button type="button" class="btn button-danger mx-1 hover-coursor" (click)="closePopup()">
              {{closeLabel}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>